import { ArrowRight, Lightbulb, ShieldCheck } from "lucide-react";
import { Logo } from "./Logo";
import { NAV_LINKS } from "@/data/content";
import { useDiagnostic } from "./DiagnosticContext";
import { Reveal } from "./Reveal";
import { LEGAL_LINE, CONTACT_EMAIL } from "@/lib/site";

export const CtaBand = () => {
  const { open } = useDiagnostic();
  return (
    <div className="mx-auto max-w-[1360px] px-5 pb-10 lg:px-10">
      <Reveal>
        <section data-testid="cta-band" className="relative overflow-hidden rounded-2xl bg-[#0B1B33] px-6 py-7 md:px-12">
          <div className="pointer-events-none absolute -right-20 -top-24 h-72 w-72 rounded-full bg-[#14B8A6]/25 blur-3xl" />
          <div className="relative flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
            <div className="flex items-center gap-5">
              <Lightbulb className="floaty h-12 w-12 shrink-0 text-white" strokeWidth={1.4} />
              <div>
                <h2 className="font-display text-[24px] font-bold tracking-tight text-white md:text-[28px]">Get a realistic first project milestone</h2>
                <p className="mt-1 max-w-[460px] text-[15px] text-slate-300">Complete the diagnostic and receive a tailored project starting point and next recommended step.</p>
              </div>
            </div>
            <button data-testid="cta-band-btn" onClick={() => open()}
              className="btn-teal flex items-center justify-center gap-2 rounded-xl px-10 py-4 text-[17px] font-semibold md:min-w-[300px]">
              Start My Diagnostic <ArrowRight className="arrow h-5 w-5" />
            </button>
          </div>
        </section>
      </Reveal>
    </div>
  );
};

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-slate-200 bg-white">
    <div className="mx-auto grid max-w-[1360px] gap-8 px-5 py-8 lg:grid-cols-[1fr_auto_1fr] lg:items-center lg:px-10">
      <div>
        <Logo sub="Practical AI projects. Real-world context." testId="footer-logo" />
      </div>
      <nav className="flex flex-wrap gap-x-5 gap-y-2 text-[14px] text-slate-700">
        {NAV_LINKS.map((l) => <a key={l.href} href={l.href} data-testid={`footer-link-${l.href.slice(1)}`} className="hover:text-[#0E9384]">{l.label}</a>)}
      </nav>
      <div data-testid="footer-privacy-note" className="flex gap-4 lg:justify-self-end">
        <ShieldCheck className="h-10 w-10 shrink-0 text-[#0B1B33]" strokeWidth={1.4} />
        <div className="max-w-[340px] text-[13px] text-slate-600">
          <p className="font-semibold text-[#0B1B33]">Privacy &amp; Responsible Data Use</p>
          We respect your privacy. Your responses are used only to personalize guidance and are never sold or shared.
        </div>
      </div>
    </div>
    <div data-testid="footer-legal" className="border-t border-slate-100 px-5 py-4 text-center text-[13px] text-slate-600">
      <p>© {new Date().getFullYear()} Bharat Reborn Private Limited. All rights reserved.</p>
      <p className="mt-1">{LEGAL_LINE} Contact: <a href={`mailto:${CONTACT_EMAIL}`} className="underline">{CONTACT_EMAIL}</a> · <a href="/privacy" className="underline">Privacy</a></p>
    </div>
  </footer>
);
